import React, { useState } from 'react';
import { useContext } from 'react';
import {AuthContextUser} from "../auth/AuthContext";
import './ChangePasswordModal.css';

interface ChangePasswordModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
                                                                            isOpen,
                                                                            onClose
                                                                        }) => {
    const { changePassword } = useContext(AuthContextUser);

    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: ''
    });

    const [errors, setErrors] = useState({
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: ''
    });

    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const validateForm = (): boolean => {
        const newErrors = {
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: ''
        };

        let isValid = true;

        if (!formData.currentPassword) {
            newErrors.currentPassword = 'Aktualne hasło jest wymagane';
            isValid = false;
        }

        if (!formData.newPassword) {
            newErrors.newPassword = 'Nowe hasło jest wymagane';
            isValid = false;
        } else if (formData.newPassword.length < 6) {
            newErrors.newPassword = 'Hasło musi mieć minimum 6 znaków';
            isValid = false;
        }

        if (!formData.confirmNewPassword) {
            newErrors.confirmNewPassword = 'Potwierdzenie hasła jest wymagane';
            isValid = false;
        } else if (formData.newPassword !== formData.confirmNewPassword) {
            newErrors.confirmNewPassword = 'Hasła nie są zgodne';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Wyczyść błąd dla tego pola
        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);

        try {
            await changePassword(formData);

            // Reset formularza
            setFormData({
                currentPassword: '',
                newPassword: '',
                confirmNewPassword: ''
            });

            onClose();
        } catch (error) {
            // Błędy są obsługiwane w kontekście przez toast
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setFormData({
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: ''
        });
        setErrors({
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: ''
        });
        onClose();
    };

    return (
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Zmiana hasła</h2>
                    <button className="close-btn" onClick={handleClose}>
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="currentPassword">Aktualne hasło</label>
                        <input
                            type="password"
                            id="currentPassword"
                            name="currentPassword"
                            value={formData.currentPassword}
                            onChange={handleChange}
                            className={errors.currentPassword ? 'error' : ''}
                            autoComplete="current-password"
                        />
                        {errors.currentPassword && (
                            <span className="error-text">{errors.currentPassword}</span>
                        )}
                    </div>

                    <div className="form-group">
                        <label htmlFor="newPassword">Nowe hasło</label>
                        <input
                            type="password"
                            id="newPassword"
                            name="newPassword"
                            value={formData.newPassword}
                            onChange={handleChange}
                            className={errors.newPassword ? 'error' : ''}
                            autoComplete="new-password"
                        />
                        {errors.newPassword && (
                            <span className="error-text">{errors.newPassword}</span>
                        )}
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmNewPassword">Potwierdź nowe hasło</label>
                        <input
                            type="password"
                            id="confirmNewPassword"
                            name="confirmNewPassword"
                            value={formData.confirmNewPassword}
                            onChange={handleChange}
                            className={errors.confirmNewPassword ? 'error' : ''}
                            autoComplete="new-password"
                        />
                        {errors.confirmNewPassword && (
                            <span className="error-text">{errors.confirmNewPassword}</span>
                        )}
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="btn-cancel"
                            disabled={loading}
                        >
                            Anuluj
                        </button>
                        <button
                            type="submit"
                            className="btn-submit"
                            disabled={loading}
                        >
                            {loading ? 'Zmieniam...' : 'Zmień hasło'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};